import { NgModule } from '@angular/core';

import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from '@routingModule';
import { SharedModule } from '../../../shared/shared.module';
import { MaterialModule } from '@modules/material.module';
import { MovimentacaoCaixaComponent as MovimentacaoCaixaComponent } from './components/movimentacao-caixa.component';
import { PrimengModule } from '@modules/primeng.module';
import { MovimentacaoCaixaResolver } from './movimentacao-caixa.resolver';
import { MovimentacaoCaixaApiService } from './services/movimentacao-caixa-api.service';
import { CadastroLoteLancamentosDialogModule } from '../../../shared/dialogs/cadastro-lote-lancamentos-dialog/cadastro-lote-lancamentos-dialog.module';

@NgModule({
  declarations: [
    MovimentacaoCaixaComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    MaterialModule,
    PrimengModule,
    CadastroLoteLancamentosDialogModule,
  ],
  providers: [
    { provide: MovimentacaoCaixaApiService, useClass: MovimentacaoCaixaApiService },
    MovimentacaoCaixaResolver
  ],
})
export class MovimentacaoCaixaModule { }
